var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTwoMarkers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44.665,
    height: 44.706,
    viewBox: "0 0 44.665 44.706",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.233 -186.041)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.233 199.479)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.194,240.728a10.974,10.974,0,0,0-10.961,10.961c0,3.753,1.785,7.787,5.306,11.992.523.625,1.044,1.2,1.545,1.732-2.273.62-3.638,1.735-3.638,3.036,0,2.3,3.992,3.546,7.749,3.546s7.749-1.243,7.749-3.546c0-1.3-1.365-2.415-3.636-3.036a35.7,35.7,0,0,0,2.811-3.343.656.656,0,0,0-1.055-.778,35.2,35.2,0,0,1-3.386,3.912.655.655,0,0,0-.286.284c-.947.93-1.743,1.62-2.2,2-.447-.374-1.231-1.054-2.166-1.972a.656.656,0,0,0-.329-.327c-2.969-2.987-7.156-8.147-7.156-13.5a9.65,9.65,0,0,1,19.3,0,14.77,14.77,0,0,1-2.354,7.459.656.656,0,1,0,1.127.67,16.043,16.043,0,0,0,2.538-8.129A10.974,10.974,0,0,0,122.194,240.728Zm-.4,28.122a.655.655,0,0,0,.8,0,33.29,33.29,0,0,0,2.636-2.344c2.211.451,3.4,1.319,3.4,1.944,0,.467-.64,1.017-1.669,1.437a13.067,13.067,0,0,1-4.768.8c-3.93,0-6.437-1.324-6.437-2.235,0-.626,1.189-1.494,3.4-1.944A33.287,33.287,0,0,0,121.793,268.85Z",
    transform: "translate(-111.233 -240.728)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.429 205.675)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.212,265.94a4.726,4.726,0,0,0-2.851.947.656.656,0,1,0,.785,1.05,3.455,3.455,0,1,1-1.389,2.769,3.466,3.466,0,0,1,.133-.955.655.655,0,1,0-1.26-.362,4.767,4.767,0,1,0,4.581-3.449Z",
    transform: "translate(-136.446 -265.94)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.746 186.041)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.215,205.087c.334-.358.677-.744,1.022-1.155,2.729-3.26,4.113-6.394,4.113-9.314a8.577,8.577,0,0,0-16.478-3.338.656.656,0,0,0,1.208.511,7.266,7.266,0,0,1,13.96,2.828c0,5.418-5.688,10.608-7.265,11.943-.348-.294-.895-.775-1.537-1.4a.654.654,0,0,0-.291-.29c-2.263-2.279-5.437-6.2-5.437-10.249a.656.656,0,0,0-1.311,0c0,2.921,1.384,6.055,4.113,9.314.345.411.688.8,1.021,1.155-1.69.508-2.666,1.372-2.666,2.413,0,.878.712,1.651,2.005,2.178a12.385,12.385,0,0,0,8.2,0c1.293-.527,2-1.3,2-2.178C237.881,206.46,236.9,205.595,235.215,205.087Zm-3.441,3.978c-3.1,0-4.8-1.035-4.8-1.566,0-.346.77-.98,2.415-1.33a25.521,25.521,0,0,0,1.981,1.757.655.655,0,0,0,.8,0,25.514,25.514,0,0,0,1.981-1.757,6.011,6.011,0,0,1,1.811.656c.377.23.6.482.6.674C236.57,208.03,234.877,209.065,231.774,209.065Z",
    transform: "translate(-223.198 -186.041)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.508 190.802)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.39,205.418a3.815,3.815,0,1,0,3.815,3.815A3.819,3.819,0,0,0,246.39,205.418Zm0,6.318a2.5,2.5,0,1,1,2.5-2.5A2.506,2.506,0,0,1,246.39,211.736Z",
    transform: "translate(-242.575 -205.418)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.299 206.843)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.828,270.7h-.3a4.955,4.955,0,0,0-.651.043.656.656,0,0,0,.173,1.3,3.649,3.649,0,0,1,.478-.031h.3a.656.656,0,1,0,0-1.311Z",
    transform: "translate(-217.308 -270.696)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135.13 226.512)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210,350.739h0l-.866,0a.655.655,0,0,0,0,1.311h0l.866,0a.655.655,0,0,0,0-1.311Z",
    transform: "translate(-208.481 -350.739)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.075 215.335)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.988,305.253h-.866a.656.656,0,0,0,0,1.311h.866a.656.656,0,0,0,0-1.311Z",
    transform: "translate(-220.467 -305.253)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.413 207.968)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.273,275.484a.656.656,0,0,0-.926-.037,4.909,4.909,0,0,0-.661.747.656.656,0,1,0,1.065.765,3.632,3.632,0,0,1,.485-.548A.656.656,0,0,0,207.273,275.484Z",
    transform: "translate(-205.563 -275.273)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.593 226.496)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.1,350.674h0l-.866,0a.656.656,0,0,0,0,1.311h0l.866,0a.656.656,0,0,0,0-1.311Z",
    transform: "translate(-222.576 -350.674)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.666 226.528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25563",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25563",
    d: "M195.908,350.8h0l-.866,0a.656.656,0,0,0,0,1.311h0l.866,0a.656.656,0,0,0,0-1.311Z",
    transform: "translate(-194.387 -350.802)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.921 214.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.318,301.065a3.6,3.6,0,0,1-.576-.451.656.656,0,1,0-.909.945,4.912,4.912,0,0,0,.785.615.656.656,0,1,0,.7-1.109Z",
    transform: "translate(-207.632 -300.431)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.618 211.045)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.707,289.187a3.626,3.626,0,0,1-.066-.691v-.036a.655.655,0,0,0-.648-.663h-.008a.656.656,0,0,0-.655.648v.052a4.945,4.945,0,0,0,.09.942.656.656,0,0,0,1.287-.251Z",
    transform: "translate(-202.329 -287.796)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.539 215.335)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.084,305.253h-.866a.656.656,0,0,0,0,1.311h.866a.656.656,0,0,0,0-1.311Z",
    transform: "translate(-234.562 -305.253)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.805 216.047)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.122,308.774a6.206,6.206,0,0,0-.8-.538.656.656,0,1,0-.644,1.142,4.933,4.933,0,0,1,.633.425.656.656,0,1,0,.813-1.029Z",
    transform: "translate(-276.342 -308.151)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.984 226.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.028,350.848a.656.656,0,0,0-.739-.56,4.946,4.946,0,0,1-.654.046h-.123a.656.656,0,0,0,0,1.311h.126a6.266,6.266,0,0,0,.827-.058A.656.656,0,0,0,267.028,350.848Z",
    transform: "translate(-264.86 -350.282)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.244 224.919)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M279.931,344.459a.655.655,0,0,0-.927-.022,4.968,4.968,0,0,1-.592.482.656.656,0,1,0,.747,1.078,6.243,6.243,0,0,0,.749-.611A.656.656,0,0,0,279.931,344.459Z",
    transform: "translate(-278.13 -344.255)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.318 221.927)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.572,332.092a.656.656,0,0,0-.765.523,4.907,4.907,0,0,1-.2.736.656.656,0,1,0,1.235.44,6.239,6.239,0,0,0,.253-.934A.656.656,0,0,0,287.572,332.092Z",
    transform: "translate(-286.569 -332.08)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.121 218.546)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.357,319.606a6.2,6.2,0,0,0-.339-.907.656.656,0,0,0-1.188.554,4.886,4.886,0,0,1,.267.714.656.656,0,0,0,1.26-.362Z",
    transform: "translate(-285.767 -318.321)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.002 215.335)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.178,305.253h-.866a.656.656,0,0,0,0,1.311h.866a.656.656,0,1,0,0-1.311Z",
    transform: "translate(-248.657 -305.253)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.057 226.48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.193,350.61h0l-.866,0a.656.656,0,0,0,0,1.311h0l.866,0a.656.656,0,0,0,0-1.311Z",
    transform: "translate(-236.671 -350.61)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.466 215.335)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.3,305.259c-.093,0-.187-.006-.279-.006h-.616a.656.656,0,0,0,0,1.311h.616c.074,0,.148,0,.221,0h.029a.655.655,0,0,0,.029-1.31Z",
    transform: "translate(-262.752 -305.253)",
    fill: "#85cb3f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.52 226.465)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.287,350.546h0l-.866,0a.656.656,0,0,0,0,1.311h0l.866,0a.656.656,0,0,0,0-1.311Z",
    transform: "translate(-250.765 -350.546)",
    fill: "#85cb3f"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwoMarkers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/two-markers.8af43949.svg";
export { ForwardRef as ReactComponent };